import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './index.css';
import './styles/design-tokens.css';
import './styles/ui-patterns.css';
import './styles/system-polish.css';
import './styles/sister-pages.css';
import theme from './styles/theme';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Prevent mouse wheel from changing focused number inputs.
if (typeof window !== 'undefined') {
  window.addEventListener(
    'wheel',
    () => {
      const active = document.activeElement;
      if (active && active.tagName === 'INPUT' && active.type === 'number') {
        active.blur();
      }
    },
    { passive: true }
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
